"use strict";

exports.__esModule = true;
exports.AuthController = void 0;
var _react = require("react");
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Provides authentication information to consumers.
 */
var AuthController = exports.AuthController = /*#__PURE__*/function (_Component) {
  function AuthController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = makeState(_this.props);
    return _this;
  }
  _inheritsLoose(AuthController, _Component);
  AuthController.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.token === nextProps.token && prevState.refreshToken === nextProps.refreshToken) {
      return null;
    }
    return makeState(nextProps);
  };
  var _proto = AuthController.prototype;
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return AuthController;
}(_react.Component);
function makeState(_ref) {
  var token = _ref.token,
    refreshToken = _ref.refreshToken,
    logout = _ref.logout;
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace("-", "+").replace("_", "/");
  var decoded = JSON.parse(atob(base64));
  var username = decoded.sub;
  var tenantName = decoded.tnt;
  var permissions = decoded.prm;
  return {
    token: token,
    refreshToken: refreshToken,
    logout: logout,
    username: username,
    tenantName: tenantName,
    permissions: permissions
  };
}